export const getLocalizedContent = (content) => {
    if(!content) return;
    return content['en'];
};
